import { t } from '@lingui/core/macro';

export const translateTask = (name) =>
  ({
    'galaxy_ng.app.tasks.import_and_auto_approve': t`Import and auto approve`,
    'galaxy_ng.app.tasks.import_and_move_to_staging': t`Import and move to staging`,
    'galaxy_ng.app.tasks.promotion._remove_content_from_repository': t`Remove content from repository`,
    'galaxy_ng.app.tasks.publishing.import_and_auto_approve': t`Import and auto approve`,
    'pulp_ansible.app.tasks.collections.collection_sync': t`Collections sync`,
    'pulp_ansible.app.tasks.collections.import_collection': t`Import collection`,
    'pulp_ansible.app.tasks.collections.sync': t`Collections sync`,
    'pulp_ansible.app.tasks.collections.update_collection_remote': t`Update collection remote`,
    'pulp_ansible.app.tasks.copy.copy_content': t`Ansible copy content`,
    'pulp_ansible.app.tasks.roles.synchronize': t`Roles sync`,
    'pulp_container.app.tasks.build_image_from_containerfile': t`Build image from Containerfile`,
    'pulp_container.app.tasks.general_multi_delete': t`General multi delete`,
    'pulp_container.app.tasks.recursive_add_content': t`Recursive add content`,
    'pulp_container.app.tasks.recursive_remove_content': t`Recursive remove content`,
    'pulp_container.app.tasks.synchronize': t`Registry sync`,
    'pulp_container.app.tasks.tag_image': t`Tag image`,
    'pulp_container.app.tasks.untag_image': t`Untag image`,
    'pulp_deb.app.tasks.synchronizing.synchronize': t`Debian sync`,
    'pulp_deb.app.tasks.publishing.publish': t`Debian publish`,
    'pulp_deb.app.tasks.publishing.publish_verbatim': t`Debian verbatim publish`,
    'pulp_deb.app.tasks.copy.copy_content': t`Debian copy content`,
    'pulp_gem.app.tasks.synchronizing.synchronize': t`Ruby gems sync`,
    'pulp_gem.app.tasks.publishing.publish': t`Ruby gems publish`,
    'pulp_file.app.tasks.synchronizing.synchronize': t`File content sync`,
    'pulp_file.app.tasks.publishing.publish': t`File content publish`,
    'pulp_python.app.tasks.sync.sync': t`Python package sync`,
    'pulp_python.app.tasks.publish.publish': t`Python package publish`,
    'pulp_python.app.tasks.upload.upload': t`Python package upload`,
    'pulp_python.app.tasks.upload.upload_group': t`Python package group upload`,
    'pulp_rpm.app.tasks.synchronizing.synchronize': t`RPM package sync`,
    'pulp_rpm.app.tasks.publishing.publish': t`RPM package publish`,
    'pulp_rpm.app.tasks.comps.upload_comps': t`RPM comps upload`,
    'pulp_rpm.app.tasks.signing.sign_and_create': t`RPM package upload & sign`,
    'pulp_rpm.app.tasks.copy.copy_content': t`RPM copy package`,
    'pulp_rpm.app.tasks.prune.prune_packages': t`RPM prune packages`,
    'pulp_ostree.app.tasks.synchronizing.synchronize': t`Ostree sync`,
    'pulp_ostree.app.tasks.importing.import_all_refs_and_commits': t`Ostree full upload`,
    'pulp_ostree.app.tasks.importing.import_child_commits': t`Ostree child upload`,
    'pulp_ostree.app.tasks.modifying.modify_content': t`Ostree modify content`,
    'pulpcore.app.tasks.export.pulp_export': t`Pulp export`,
    'pulpcore.app.tasks.pulp_import': t`Pulp import`,
    'pulpcore.app.tasks.repository.add_and_remove': t`Add and remove content`,
    'pulpcore.app.tasks.repository.delete_version': t`Delete repository version`,
    'pulpcore.app.tasks.repository.repair_version': t`Repair repository version`,
    'pulpcore.app.tasks.upload.commit': t`Upload commit`,
    'pulpcore.plugin.tasking.add_and_remove': t`Add or remove content`,
    'pulpcore.app.tasks.base.general_create': t`General create`,
    'pulpcore.app.tasks.base.general_delete': t`General delete`,
    'pulpcore.app.tasks.base.general_update': t`General update`,
    'pulpcore.app.tasks.orphan.orphan_cleanup': t`Orphan cleanup`,
    'pulpcore.app.tasks.repository.repair_all_artifacts': t`Repair all artifacts`,
    'pulpcore.app.tasks.purge.purge': t`Purge all tasks`,
  })[name] || name;
